import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {map} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RciApiService {

  public guid:string;

  constructor(private http: HttpClient) {
  }

  responseData(response) {
    return response.data
  }

  isBalloonFinance(condition) {
    return condition.calculationTypeCode === 'F' && condition.contractKindCode !== '1'; // not Vario
  }

  uniqueNum(arr) {
    return Object.keys(arr.reduce(
      (o, x) => {
        o[x] = 1;
        return o;
      }, {})).map(Number);
  }

  durationValuesFromConditions(condition) {
    var allDurations = condition.durations.map((duration) => {
      return duration.duration;
    });
    return this.uniqueNum(allDurations);
  }

  milageValuesFromConditions(condition) {
    return condition.balloon || condition.calculationTypeCode === 'L' ? condition.mileages : [];
  }

  createContentInfo(contentInfoFinance, calculationTypeCode, brand) {
    var bankName;
    switch (brand) {
      case 'REN':
        bankName = 'Mobilize Financial Services';
        break;
      case 'DAC':
        bankName = 'Mobilize Financial Services';
        break;
      case 'NIS':
        bankName = 'Nissan Financial Services';
        break;
      case 'RCI':
        bankName = 'RCI Banque S.A.';
        break;
    }

    return contentInfoFinance.replace('${bankname}', bankName);
  }

  getConditions(conditionParams) {
    return this.http.post('/calculatorservice/conditions', conditionParams || {'offerCode': 'test'}).pipe(
      map((obj:any) => {
        conditionParams.hsn = obj.vehicle.hsn;
        conditionParams.tsn = obj.vehicle.tsn;
        if (!obj.header.code) {
          obj.header.code = '4711';
        }
        var minPrepaymentAmount = environment.minPrepayment;
        if (conditionParams.styleBrand !== 'DAC') {
          minPrepaymentAmount = 0;
        }
        var totalVehiclePrice = (obj.vehicle.vehiclePrice || obj.vehiclePriceDefault) + (obj.vehicle.accessoriesPrice || 0);
        if (obj.vehicle.type !== 'G') {
          totalVehiclePrice = totalVehiclePrice + (obj.vehicle.optionPrice || 0) + (obj.vehicle.transportPrice || 0);
        }
        let usedPrepayment = Math.round(totalVehiclePrice * obj.prepaymentPercentDefault);
        if (obj.calculationDefault && obj.calculationDefault.downpaymentAbsoluteGross) {
          usedPrepayment = obj.calculationDefault.downpaymentAbsoluteGross;
        }
        obj.defaults = {
          mileage: obj.defaultMileage,
          prepaymentPrice: usedPrepayment,
          prepaymentPercentMin: obj.prepaymentPercentMin,
          prepaymentPercentMax: obj.prepaymentPercentMax,
          prepaymentPercentDefault: obj.prepaymentPercentDefault,
          minPrepaymentPrice: Math.round(totalVehiclePrice * obj.prepaymentPercentMin) | minPrepaymentAmount,
          maxPrepaymentPrice: Math.round(totalVehiclePrice * obj.prepaymentPercentMax),
          minVehiclePrice: obj.vehiclePriceMin,
          maxVehiclePrice: obj.vehiclePriceMax,
          contentInfoFinanceTemplate: obj.contentInfoFinance,
          rsv: false,
          gap: false
        };
        obj.conditions.forEach((condition) => {
          condition.balloon = this.isBalloonFinance(condition);
          condition.durationsValues = this.durationValuesFromConditions(condition);
          condition.mileageValues = this.milageValuesFromConditions(condition);
          condition.contractKindDescription += condition.calculationTypeCode === 'F' ? ' Finanzierung' : '';
          condition.contentInfo = this.createContentInfo(obj.contentInfoFinance, condition.calculationTypeCode, conditionParams.styleBrand);
        });
        return obj;
      })
    );
  }

  getFinance(options) {
    return this.http.post('/calculatorservice/finance', options);
  }

  getLeasing(options) {
    return this.http.post('/calculatorservice/leasing', options);
  }

  saveData(data) {
    return this.http.post('/calculatorservice/callback/create', data, {responseType: 'text'}).pipe(map((response: any) => response));
  }

  printPdf(data) {
    var form = document.createElement('form');
    form.action = '/calculatorservice/pdf';
    form.method = 'POST';
    form.target = '_blank';
    if (data) {
      for (var key in data) {
        var input = document.createElement('input');
        input.name = key;
        console.log(data[key])
        input.value = typeof data[key] === 'object' ? JSON.stringify(data[key]) : data[key];
        form.appendChild(input);
      }
    }
    form.style.display = 'none';
    document.body.appendChild(form);
    form.submit();
  }


  sendParamMismatchEmail(data) {
    console.log('sendParamMismatchEmail', data);
    return this.http.post('/calculatorservice/paramMismatch', data);
  }

  createGuid() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });

  }

  getDealerEmail(rciNetNumber) {
    console.log('get dealer email for rciNetNumber : ', rciNetNumber);
    return this.http.get(`/api/rciws/email/${rciNetNumber}`);
  }

  getDealerAddress(rciNetNumber, dealerName) {
    console.log('get dealer address for rciNetNumber : ', rciNetNumber, dealerName);
    return this.http.get(`/api/rciws/dealerAddress?netnumber=${rciNetNumber}&dealername=${encodeURI(dealerName)}`);
  }
}
